import React, {Fragment, useEffect, useRef} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import FormGroup from "@mui/material/FormGroup";
import SvgIcon from "@mui/material/SvgIcon";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import HelpIcon from '@mui/icons-material/Help';

import LookUserInput from "../../user/lookUserInput";
import LookUserPhoneInput from "../../user/lookUserPhoneInput";
import {UserPopupContent} from "../../../visComponents/constants";
import {setUserPopupContent} from "../../../../actions/userFunctions";


const LeadCapturePopupContentInputs = (props) => {

  const {userPopupContent, inputsValidated, setUserPopupContent} = props;

  const formRef = useRef(null);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => () => clearTimeout(scrollTimeoutRef.current), []);

  // On mobile `grohe-lead__left` is scrollable. When the last input loses focus (keyboard closed)
  // and focus doesn't move to another field, scroll down so the footer submit button is visible.
  const handleInputBlur = (event) => {
    const form = formRef.current;
    const target = event.target;
    if (!form || !target || target.tagName !== "INPUT") {
      return;
    }

    const inputs = form.querySelectorAll("input:not([type=hidden])");
    const lastInput = inputs[inputs.length - 1];
    if (target !== lastInput) {
      return;
    }

    const next = event.relatedTarget;
    if (next && form.contains(next)) {
      return;
    }

    clearTimeout(scrollTimeoutRef.current);
    scrollTimeoutRef.current = setTimeout(() => {
      const scrollContainer = form.closest(".grohe-lead__left");
      if (!scrollContainer || (document.activeElement && document.activeElement.tagName === "INPUT")) {
        return;
      }
      scrollContainer.scrollTo({top: scrollContainer.scrollHeight, behavior: "smooth"});
    }, 300);
  }

  const forgotPasswordLinkClick = () => {
    setUserPopupContent(userPopupContent === UserPopupContent.forgot ? UserPopupContent.login : UserPopupContent.forgot);
  }

  return (
    <FormGroup className="grohe-lead__form" ref={formRef} onBlur={handleInputBlur}>
      {userPopupContent === UserPopupContent.register ? (
        <Fragment>
          <LookUserInput property={"firstName"} inputsValidated={inputsValidated} shrink={true} tabIndex={1} />
          <LookUserPhoneInput property={"phoneNumber"} inputsValidated={inputsValidated} shrink={true} tabIndex={2} />
        </Fragment>
      ) : null}
      <LookUserInput property="email" inputsValidated={inputsValidated} shrink={true} tabIndex={3} />
      {userPopupContent === UserPopupContent.register
        ? <LookUserInput property="postal" inputsValidated={inputsValidated} shrink={true} tabIndex={4} />
        : null}
      {userPopupContent === UserPopupContent.login
        ? <LookUserInput property="password" inputsValidated={inputsValidated} shrink={true} tabIndex={4} />
        : null}
      {userPopupContent === UserPopupContent.login || userPopupContent === UserPopupContent.forgot ? (
        <div>
          {userPopupContent === UserPopupContent.forgot ? (
            <div className="grohe-lead__link"  onClick={forgotPasswordLinkClick}>
              <SvgIcon className="grohe-lead__link-icon">
                <ChevronLeftIcon/>
              </SvgIcon>
              <FormattedMessage id="buttons.back"/>
            </div>
          ) : null}
          {userPopupContent === UserPopupContent.login ? (
            <div className="grohe-lead__link"  onClick={forgotPasswordLinkClick}>
              <SvgIcon className="grohe-lead__link-icon">
                <HelpIcon/>
              </SvgIcon>
              <FormattedMessage id="leadCapturePopup.forgotLink"/>
            </div>
          ) : null}
        </div>
      ) : null}
    </FormGroup>
  )
};

LeadCapturePopupContentInputs.propTypes = {
  inputsValidated: PropTypes.bool.isRequired
}

const mapStateToProps = (store) => {
  const {userPopupContent} = store.userState;

  return {
    userPopupContent,
  };
};

const mapDispatchToProps = {
  setUserPopupContent
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadCapturePopupContentInputs)
